
        <!-- headers -->
        <section>
            <span class="slide-no">{{slideshow.getSlideNumber(slide, i)}}</span>
            <span class="slide-id" *ngIf="slideshow.quiz || !slide.intro">{{slideshow.getSlideID(slide, i)}}</span>
            <button *ngIf="!slideshow.locked && !slideshow.quiz && permissionsService.userHasPermission(Permissions.UseSlideAi)" 
                    class="ai-button mat-stroked-button transparent" 
                    matTooltip="Generate Content from AI"
                    matTooltipPosition="above"
                    (click)="showMlDialog(i)">AI</button>
            <div *ngIf="!slide.intro && !slide.outro">
                <richtext 
                    class="h2"
                    [(value)]="slide.title"
                    (blur)="slideshow.titleChange(slide)"
                    placeholder="{{ slideshow.quiz ? 'Question' : 'Slide Headline'}}"
                    *ngIf="!slideshow.locked; else h2">
                </richtext>
                <ng-template #h2><h2 [innerHTML]="slide.title"></h2></ng-template>
            </div>
        </section>

        <!-- images -->
        <image-component
            *ngIf="!slide.intro && (!slideshow.quiz || !slide.outro) && !slide.embedContent" 
            (slideImagesChange)="cdr.markForCheck()"
            [(images)]="slide.images"
            [(imagesMobile)]="slide.imagesMobile" 
            [canEdit]="!slideshow.locked">
        </image-component>

        <!-- embeds -->
        <embed-content-component
            *ngIf="!slide.intro && (!slideshow.quiz || !slide.outro) && slide.embedContent" 
            (embedChange)="cdr.markForCheck()"
            [(embed)]="slide.embed" 
            [canEdit]="!slideshow.locked">
        </embed-content-component>

        <!-- caption -->
        <section class="caption" *ngIf="!slide.intro && (!slideshow.quiz || !slide.outro) && slide.images.length > 0">
            <ng-container *ngIf="!slideshow.locked; else captionText">
                <div [ngClass]="{'show-mobile': slide.imagesMobile.length > 0}">
                    <div>
                        <label *ngIf="slide.images[0].caption">{{slide.imagesMobile.length == 0 ? 'Desktop & Mobile ' : 'Desktop '}}Caption</label>
                        <richtext 
                            [(value)]="slide.images[0].caption"
                            placeholder="Caption">
                        </richtext> 
                        <span class="word-count"></span>
                    </div>
                    <div *ngIf="slide.imagesMobile.length > 0">
                        <label *ngIf="slide.imagesMobile[0].caption">Mobile Caption</label>
                        <richtext 
                            [(value)]="slide.imagesMobile[0].caption"
                            placeholder="Mobile Caption"
                            *ngIf="slide.imagesMobile.length > 0">
                        </richtext> 
                        <span class="word-count"></span>
                    </div>
                </div>
            </ng-container>
            <ng-template #captionText>
                <div [ngClass]="{'show-mobile': slide.imagesMobile.length > 0}">
                    <div>
                        <label *ngIf="slide.images[0].caption">{{slide.imagesMobile.length == 0 ? 'Desktop & Mobile ' : 'Desktop '}}Caption</label>
                        <p [ngClass]="{faded: slide.images[0].caption ? false : true}" [innerHtml]="slide.images[0].caption ? slide.images[0].caption : 'Caption'"></p>
                    </div>
                    <div *ngIf="slide.imagesMobile.length > 0">
                        <label *ngIf="slide.imagesMobile[0].caption">Mobile Caption</label>
                        <p [ngClass]="{faded: slide.imagesMobile[0].caption ? false : true}" [innerHtml]="slide.imagesMobile[0].caption ? slide.imagesMobile[0].caption : 'Mobile Caption'"></p>
                    </div>
                </div>
            </ng-template>
        </section>
        <!-- content -->
        <section class="cf">
            <!-- summary -->
            <div *ngIf="slideshow.summary && !slide.intro">
                <div class="wysiwyg summary">
                    <richtext 
                        placeholder="Buzz summary"
                        [value]="slide.summary"
                        (valueChange)="slideshow.contentChange($event, slide, 'summary')"
                        id="summary-{{i}}"
                        [enableReturn]="true"
                        *ngIf="!slideshow.locked; else paragraphs">
                    </richtext>
                    <ng-template #paragraphs><div [innerHTML]="getContent(slide.summary)"></div></ng-template>
                    <div class="word-count summary-split"></div>
                </div>
            </div>
            <!-- slideshow -->
            <div *ngIf="!slideshow.quiz || slide.intro">
                <div class="wysiwyg">
                    <richtext 
                        placeholder="What's the buzz?"
                        [value]="slide.content"
                        (valueChange)="slideshow.contentChange($event, slide, 'content')"
                        id="content-{{i}}"
                        [enableReturn]="true"
                        *ngIf="!slideshow.locked; else paragraphs">
                    </richtext>
                    <ng-template #paragraphs><div [innerHTML]="getContent(slide.content)"></div></ng-template>
                    <div *ngIf="slideshow.summary" class="word-count">{{getWordCount(slide.summary) + getWordCount(slide.content)}}/{{slideshow.assignment.slideWordCount}}</div>
                    <div *ngIf="!slideshow.summary" class="word-count">{{getWordCount(slide.content)}}/{{slideshow.assignment.slideWordCount}}</div>
                </div>
            </div>
            <!-- quiz -->
            <div *ngIf="slideshow.quiz && !slide.intro && !slide.outro" fxLayout="column" fxLayoutGap="10px">
                <div 
                    [ngClass]="{personality: slideshow.assignment.quizType === 'personality'}" 
                    fxLayout="row" 
                    fxLayoutGap="20px" 
                    fxLayoutAlign="start" 
                    *ngFor="let answer of slide.content; let answerIndex = index; trackBy: utils.trackByIndex">
                    <mat-checkbox  *ngIf="slideshow.assignment.quizType !== 'personality'; else personality"
                        class="correct"
                        name="answer-correct-{{answerIndex}}"
                        [(ngModel)]="slide.content[answerIndex].correct"
                        [disabled]="slideshow.locked"
                        >
                    </mat-checkbox>
                    <ng-template #personality>
                        <mat-form-field floatLabel="never" fxFlex="50" class="personality-select {{slideshow.locked ? '' : 'edit'}}">
                            <mat-select placeholder="Select Personality"
                                [(value)]="slide.content[answerIndex].bucket"
                                [disabled]="slideshow.locked">
                                <mat-option *ngFor="let result of slideshow.slides[slideshow.slides.length - 1].content; let resultIndex = index; trackBy: utils.trackByIndex"
                                    [value]="resultIndex" >
                                    {{result.title}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </ng-template>

                    <div class="answer" fxFlex *ngIf="!slideshow.locked; else answers">
                        <richtext 
                            placeholder="Answer"
                            [(value)]="slide.content[answerIndex].text"
                            [id]="'content-' + i + '-' + answerIndex"
                            (enter)="addContent(slide, i, answerIndex, {text: '', correct: false, bucket: 0})"
                            (delete)="removeContent(slide, i, answerIndex)">
                        </richtext>
                        <div class="word-count"></div>
                        <button mat-button matSuffix mat-icon-button aria-label="Remove" (click)="removeContent(slide, i, answerIndex, true)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>

                    <ng-template #answers><div fxFlex fxLayoutAlign="start center" [innerHTML]="getContent(slide.content[answerIndex].text)"></div></ng-template>
                </div>
                <div>
                    <button class="p-btn button transparent" *ngIf="!slideshow.locked" (click)="addContent(slide, i, slide.content.length, {text: '', correct: false, bucket: 0})">Add Answer</button>
                </div>
                <richtext
                    [(value)]="slide.feedback[0].text"
                    placeholder="{{slideshow.answerSummaryPlaceholder}}"
                    *ngIf="!slideshow.locked; else feedback">
                </richtext>
                <ng-template #feedback><div [innerHTML]="getContent(slide.feedback)"></div></ng-template>
                <div class="word-count">{{getWordCount(slide.feedback)}}/30</div>
            </div>
            <!-- quiz results -->
            <div *ngIf="slideshow.quiz && slide.outro">
                <div fxLayout="column" *ngFor="let result of slide.content; let contentIndex = index; trackBy: utils.trackByIndex">
                    <div>
                        <div fxFlex *ngIf="!slideshow.locked; else resultTitle" class="result-score">
                            <label *ngIf="slideshow.assignment.quizType === 'normal'">Score {{ getScore(contentIndex)}}</label>
                            <richtext
                                [(value)]="slide.content[contentIndex].title"
                                (valueChange)="emitResults()"
                                placeholder="Result Title">
                            </richtext>
                            <div class="word-count"></div>
                        </div>
                        <ng-template #resultTitle><div [innerHTML]="slide.content[contentIndex].title" class="result-score"></div></ng-template>
                        <button class="p-btn button transparent" *ngIf="!slideshow.locked" (click)="removeResult(slide, contentIndex)">Remove Result</button>
                    </div>
                    <div fxFlex *ngIf="!slideshow.locked; else resultSummary" class="result-summary">
                        <richtext
                            [(value)]="slide.content[contentIndex].text"
                            placeholder="Result Summary">
                        </richtext>
                        <div class="word-count"></div>
                    </div>
                    <ng-template #resultSummary><div [innerHTML]="slide.content[contentIndex].text" class="result-summary"></div></ng-template>
                    <!-- images -->
                    <image-component
                        (slideImagesChange)="setQuizResultImage($event, slide.content, contentIndex)"
                        [canEdit]="!slideshow.locked"
                        [single]="true"
                        [direct]="this.direct(slide.content, contentIndex)"
                        [singleImage]="slide.content[contentIndex].image">
                    </image-component>
                </div>
                <div>
                    <button *ngIf="!slideshow.locked" class="p-btn button transparent" (click)="addResult(slide)">Add Result</button>
                </div>
            </div>
        </section>
        <div class="buttons">
            <button class="button transparent" *ngIf="!slideshow.quiz" (click)="toggle('showTeaser', slide)">Add Teaser</button>
            <button class="button transparent" *ngIf="!slide.intro && false" (click)="toggle('showTags', slide)">Add Tags</button>
            <button class="button transparent" *ngIf="!slideshow.quiz && false" (click)="toggle('showMeta', slide)">Show Meta</button>
            <button [disabled]="slideshow.locked" class="button transparent" *ngIf="!slide.intro && (!slideshow.quiz || !slide.outro) && !slide.embedContent" (click)="toggle('embedContent', slide)">Embed Content</button>
            <button [disabled]="slideshow.locked" class="button transparent" *ngIf="!slide.intro && (!slideshow.quiz || !slide.outro) && slide.embedContent" (click)="toggle('embedContent', slide)">Remove Embed</button>
        </div>
        <!-- teaser -->
        <section fxLayout="row" fxLayoutGap="10px" *ngIf="!slideshow.quiz && slide.teaser || slide.showTeaser">
            <div fxFlex class="wysiwyg">
                <label>Teaser Text</label>
                <richtext
                    *ngIf="!slideshow.locked; else teaserEl"
                    [(value)]="slide.teaser"
                    placeholder="Teaser Text"
                    [boldButton]="false">
                </richtext>
                <ng-template #teaserEl>
                    <div [ngClass]="{faded: !slide.teaser}" [innerHTML]="slide.teaser ? slide.teaser : 'Teaser Text'"></div>
                </ng-template>
                <div class="word-count"></div>
            </div>
            <mat-form-field>
                <input name="slideTeaser" autocomplete="slideTeaser" id="slideTeaser{{slideTeaser}}" matInput placeholder="Tease to Slide" [(ngModel)]="slide.teaseToSlide" [readonly]="slideshow.locked"/>
            </mat-form-field>
        </section>
        <!-- tags -->
        <section *ngIf="slide.showTags && !slide.intro">
            <tags-component
                [(termIds)]="slide.tags"
                (termIdsChange)="addToSearch($event, i)"
                [canEdit]="!slideshow.locked">
            </tags-component>
        </section>
        <!-- meta -->
        <section fxLayout="column" fxLayoutGap="20px" *ngIf="!slideshow.quiz && slide.showMeta">
            <div class="wysiwyg">
                <label>Meta Title</label>
                <richtext
                    *ngIf="!slideshow.locked; else metaTitleEl"
                    [(value)]="slide.metaTitle"
                    placeholder="Meta Title"
                    [removeButtons]="true">
                </richtext>
                <ng-template #metaTitleEl>
                    <div [ngClass]="{faded: !slide.metaTitle}">{{slide.metaTitle ? slide.metaTitle : 'Meta Title'}}</div>
                </ng-template>
                <div class="word-count"></div>
            </div>
            <div class="wysiwyg">
                <label>Meta Description</label>
                <richtext
                    *ngIf="!slideshow.locked; else metaDescEl"
                    [(value)]="slide.metaDescription"
                    placeholder="Meta Description"
                    [removeButtons]="true">
                </richtext>
                <ng-template #metaDescEl>
                    <div [ngClass]="{faded: !slide.metaDescription}">{{slide.metaDescription ? slide.metaDescription : 'Meta Description'}}</div>
                </ng-template>
                <div class="word-count"></div>
            </div>
        </section>
        <section class="slide-buttons" *ngIf="!slideshow.locked && permissionsService.userHasPermission(Permissions.AddSlides)">
            <p class="actions">
                <button 
                    class="button"
                    [disabled]="slideshow.saving || slideshow.publishing || slideshow.retrying" 
                    (click)="slideshow.saveSlides(false, false)">
                    Save
                </button>
                <button  
                    class="button" 
                    [disabled]="slideshow.saving || slideshow.publishing || slideshow.retrying" 
                    (click)="slideshow.createSlide(i)">
                    Add New
                </button>
                <button  
                    class="button" 
                    [disabled]="slideshow.saving || slideshow.publishing || slideshow.retrying" 
                    (click)="maybeCreateMultipleSlides(i)">
                    Add Multiple
                </button>
            </p>
        </section> 